import React from "react";
import { H2HMatchRow } from "@ihs-widget/components/StatsConsole/Widgets/H2HWidget/parts/H2H/H2HMatchRow";

interface Last5MeetingsListProps {
    last5Meetings: Array<{
        date: string;
        league: string;
        homeTeam: string;
        homeScore: number;
        awayScore: number;
        awayTeam: string;
    }>;
}

export const Last5MeetingsList = ({ last5Meetings }: Last5MeetingsListProps) => {
    if (!last5Meetings || !Array.isArray(last5Meetings) || last5Meetings.length === 0) {
        return null;
    }

    return (
        <div data-testid="h2h-last-5-meetings-list-container" className="w-full flex flex-col justify-center items-center">
            {[...last5Meetings]
                .sort((a, b) => new Date(b.date).getTime() - new Date(a.date).getTime())
                .map((match, index) => (
                    <H2HMatchRow
                        key={index}
                        date={match.date}
                        league={match.league}
                        homeTeam={match.homeTeam}
                        homeScore={match.homeScore}
                        awayScore={match.awayScore}
                        awayTeam={match.awayTeam}
                    />
                ))}
        </div>
    );
}
